import {Component, Input, OnInit} from '@angular/core';

const DEFAULT_AVATAR = 'assets/images/icons/profile.svg';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit {
  @Input() src: string = '';
  @Input() size: string = '100px';

  defaultAvatar = DEFAULT_AVATAR;

  ngOnInit(): void {
  }
}
